import React, { createContext, useState } from 'react';

import {config} from './config.js';

const API_URL = config.API_URL;

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [port] = useState(API_URL);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userID, setUserID] = useState(null);
  const [token, setToken] = useState(null);

  const [alerts, setAlerts] = useState([]);

  const addAlert = (message, type = 'info', timeout = 2000) => {
    const id = crypto.randomUUID();
    
    if (alerts.length > 0) {
      removeAlert(alerts[0].id);
      
      setTimeout(() => {
        setAlerts([{ id, message, type }]);
      }, 500); // Adjust timing to match CSS transition duration
    } else {
      // If no existing alerts, add immediately
      setAlerts([{ id, message, type }]);
    }

    // Set auto-removal timeout
    setTimeout(() => {
      removeAlert(id);
    }, timeout);

    return id;
  };

  const removeAlert = (id) => {
    setAlerts(prev => prev.filter(alert => alert.id !== id));
  };

  return (
    <AppContext.Provider value={{ 
      port, 
      isLoggedIn, 
      setIsLoggedIn, 
      userID, 
      setUserID, 
      token, 
      setToken,
      alerts, 
      addAlert, 
      removeAlert}}>
      {children}
    </AppContext.Provider>
  );
};